import React from 'react';
import iconify from '../iconify';

const People = props => (
  <svg width="1em" height="1em" viewBox="6828 363.786 13.644 17.214" {...props}>
    <path
      fill="currentColor"
      d="M-6678.16 21.235v-5.847h-.736v5.848h-7.593v-5.848h-.739v5.848h-2.289v-6.588a2.592 2.592 0 0 1 1.072-2.289 4.766 4.766 0 0 1 2.765-.737h6.046a4.26 4.26 0 0 1 2.765.811 2.793 2.793 0 0 1 1 2.289v6.513zm-6.824-11.865a3.024 3.024 0 0 1-.919-2.215 3.03 3.03 0 0 1 .919-2.213 3.017 3.017 0 0 1 2.213-.922 3.02 3.02 0 0 1 2.217.922 2.986 2.986 0 0 1 .92 2.176 3.071 3.071 0 0 1-.92 2.252 3.035 3.035 0 0 1-2.217.924 3.028 3.028 0 0 1-2.212-.923z"
      transform="translate(13517.517 359.765)"
    />
  </svg>
);

export default iconify(People);
